import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import { showSuccessMessage } from "../Shared/Toast";

function Slots() {
  const [isAnimation, setIsAnimation] = useState(false);
  const [Slots, setSlotsData] = useState<any>([]);

  useEffect(() => {
    getSlots();
  }, []);

  function getSlots() {
    setIsAnimation(true);
    axiosAuth
      .get(AppContext.APIURL + "api/MNVSlotsAvailability/GetSlots")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          setSlotsData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function onFocusOutEvent(event: any, day: any, slot: any) {
    let data = {} as any;
    data.DayId = day;
    data.SlotId = slot;
    data.Slot = event.target.value;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVSlotsAvailability/UpdateSlots", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          showSuccessMessage("Data has been updated successfully!");
          getSlots();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValue(event: any, day: any, slot: any) {
    let thisslot = [...Slots];
    if (slot == 1) {
      thisslot[day].Slot1 = event.target.value;
    } else if (slot == 2) {
      thisslot[day].Slot2 = event.target.value;
    } else if (slot == 3) {
      thisslot[day].Slot3 = event.target.value;
    }

    setSlotsData(thisslot);
  }
  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <div className="flow-auto">
        <table className="reuse-table">
          <thead>
            <tr>
              <th></th>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
            </tr>
          </thead>
          <tbody>
            {Slots && Slots[0] && (
              <tr>
                <td>Tier 1</td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="1-1"
                    value={Slots[0].Slot1}
                    onChange={(e) => updateValue(e, 0, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 1, 1)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="2-1"
                    value={Slots[1].Slot1}
                    onChange={(e) => updateValue(e, 1, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 2, 1)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="3-1"
                    value={Slots[2].Slot1}
                    onChange={(e) => updateValue(e, 2, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 3, 1)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="4-1"
                    value={Slots[3].Slot1}
                    onChange={(e) => updateValue(e, 3, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 4, 1)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="5-1"
                    value={Slots[4].Slot1}
                    onChange={(e) => updateValue(e, 4, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 5, 1)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="6-1"
                    value={Slots[5].Slot1}
                    onChange={(e) => updateValue(e, 5, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 6, 1)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="7-1"
                    value={Slots[6].Slot1}
                    onChange={(e) => updateValue(e, 6, 1)}
                    onBlur={(e) => onFocusOutEvent(e, 0, 1)}
                  />
                </td>
              </tr>
            )}
            {Slots && Slots[0] && (
              <tr>
                <td>Tier 2</td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="1-2"
                    value={Slots[0].Slot2}
                    onChange={(e) => updateValue(e, 0, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 1, 2)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="2-2"
                    value={Slots[1].Slot2}
                    onChange={(e) => updateValue(e, 1, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 2, 2)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="3-2"
                    value={Slots[2].Slot2}
                    onChange={(e) => updateValue(e, 2, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 3, 2)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="4-2"
                    value={Slots[3].Slot2}
                    onChange={(e) => updateValue(e, 3, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 4, 2)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="5-2"
                    value={Slots[4].Slot2}
                    onChange={(e) => updateValue(e, 4, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 5, 2)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="6-2"
                    value={Slots[5].Slot2}
                    onChange={(e) => updateValue(e, 5, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 6, 2)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="7-2"
                    value={Slots[6].Slot2}
                    onChange={(e) => updateValue(e, 6, 2)}
                    onBlur={(e) => onFocusOutEvent(e, 0, 2)}
                  />
                </td>
              </tr>
            )}
            {Slots && Slots[0] && (
              <tr>
                <td>Tier 3</td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="1-3"
                    value={Slots[0].Slot3}
                    onChange={(e) => updateValue(e, 0, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 1, 3)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="2-3"
                    value={Slots[1].Slot3}
                    onChange={(e) => updateValue(e, 1, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 2, 3)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="3-3"
                    value={Slots[2].Slot3}
                    onChange={(e) => updateValue(e, 2, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 3, 3)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="4-3"
                    value={Slots[3].Slot3}
                    onChange={(e) => updateValue(e, 3, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 4, 3)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="5-3"
                    value={Slots[4].Slot3}
                    onChange={(e) => updateValue(e, 4, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 5, 3)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="6-3"
                    value={Slots[5].Slot3}
                    onChange={(e) => updateValue(e, 5, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 6, 3)}
                  />
                </td>
                <td className="p-all0">
                  <input
                    type="text"
                    className="text-left"
                    id="7-3"
                    value={Slots[6].Slot3}
                    onChange={(e) => updateValue(e, 6, 3)}
                    onBlur={(e) => onFocusOutEvent(e, 0, 3)}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Slots;
